import script from "./Call.vue?vue&type=script&setup=true&lang=js"
export * from "./Call.vue?vue&type=script&setup=true&lang=js"

import "./Call.vue?vue&type=style&index=0&id=670fa0be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670fa0be"]])

export default __exports__